export enum SystemSettingsEnum {
	MobileBanner = 'mobile_banner',
	MobileBannerAustin = 'mobile_banner_austin',
	MobileBannerMiami = 'mobile_banner_miami',
	MobileBannerDenver = 'mobile_banner_denver',
	LandingTravisRunResults = 'landing_travisrun_results',
	LandingTravisRunFallback = 'landing_travisrun_fallback',
	EnableShapedAiGlobally = 'enable_shaped_ai_globally',
	EnableShapedAiTrending = 'enable_shaped_ai_trending',
	EnableShapedAiUpdatedForYouRanking = 'enable_shaped_ai_updated_for_you_ranking',
	EnableCampaignsSectionGlobally = 'mobile_campaigns_section_enabled',
	EnableIosRateModalGlobally = 'mobile_enable_app_review_request',
	EditorPickFeedName = 'editor_pick_feed_name',
	PoS = 'enable_pos_feature',
	EnableOptimizedStatsQuery = 'enable_optimized_stats_query',

	/**
	 * @deprecated Was added due to the tight timelines of monetization feature, but we haven't used it
	 */
	IsMonetizationFeatureVisible = 'is_monetization_feature_visible',
}
